import type { Settings } from '../types';
import { STORAGE_KEYS } from '../constants';

const DEFAULTS: Settings = {
  loop: false,
  linear: true,
  invertPitch: false,
};

function readBool(key: string, fallback: boolean): boolean {
  try {
    const v = localStorage.getItem(key);
    if (v === 'true') return true;
    if (v === 'false') return false;
  } catch {
    /* ignore */
  }
  return fallback;
}

export function loadSettings(): Settings {
  return {
    loop: readBool(STORAGE_KEYS.loop, DEFAULTS.loop),
    linear: readBool(STORAGE_KEYS.linear, DEFAULTS.linear),
    invertPitch: readBool(STORAGE_KEYS.invertPitch, DEFAULTS.invertPitch),
  };
}

export function saveSettings(patch: Partial<Settings>): void {
  try {
    if (patch.loop !== undefined) localStorage.setItem(STORAGE_KEYS.loop, String(patch.loop));
    if (patch.linear !== undefined) localStorage.setItem(STORAGE_KEYS.linear, String(patch.linear));
    if (patch.invertPitch !== undefined)
      localStorage.setItem(STORAGE_KEYS.invertPitch, String(patch.invertPitch));
  } catch {
    /* ignore */
  }
}
